import { render, staticRenderFns } from "./product-offer-pdp.vue?vue&type=template&id=3ac08a76&scoped=true&"
import script from "./product-offer-pdp.vue?vue&type=script&lang=js&"
export * from "./product-offer-pdp.vue?vue&type=script&lang=js&"
import style0 from "./product-offer-pdp.vue?vue&type=style&index=0&id=3ac08a76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac08a76",
  null
  
)

export default component.exports